import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Col } from "antd";

import data from "./countries.json";
import dataEn from "./countries.en.json";
import SelectItem from "../form/selectItem";
import { czechLocale } from "../../languages";
import SelectItemWithLoad from "../form/selectItemWithLoad";

const Countries = ({
  span,
  onSelect,
  disabled,
  fieldName,
  initialValue,
  onSetCountries,
}) => {
  const intl = useIntl();
  const [countries, setCountries] = useState();
  useEffect(() => {
    const c = intl.locale === czechLocale ? data : dataEn;
    setCountries(c);
    onSetCountries && onSetCountries(c);
  }, [onSetCountries, intl.locale]);

  return (
    <Col span={span || 4}>
      <SelectItemWithLoad
        icon
        options={countries}
        errorMessage={
          <FormattedMessage
            id="countries.loadError"
            defaultMessage="Při načítání států nastala chyba"
          />
        }
      >
        <SelectItem
          showSearch
          allowClear
          onSelect={onSelect}
          disabled={disabled}
          options={countries}
          placeholder={
            <FormattedMessage
              id="countries.placeholder"
              defaultMessage="Vyberte stát"
            />
          }
          fieldName={fieldName || "country"}
          label={
            <FormattedMessage id="countries.label" defaultMessage="Stát" />
          }
          initialValue={initialValue}
          message={
            <FormattedMessage
              id="countries.message"
              defaultMessage="Vyberte prosím stát!"
            />
          }
        />
      </SelectItemWithLoad>
    </Col>
  );
};

export default Countries;
